import React, { Component, ReactNode } from 'react';
import { log } from 'telemetry/logger';

type ErrorBoundaryProps = {
  children: ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: { componentStack?: string }) {
    // Forward React render crashes to the observability pipeline. We deliberately
    // do NOT also console.error here: console.error is patched to enqueue, so it
    // would double-log every crash. log.error carries the structured component_stack.
    log.error('React ErrorBoundary caught an error', { source: 'react.error_boundary', component_stack: info?.componentStack }, error);
  }

  render() {
    if (this.state.hasError) {
      // Render a fallback UI
      return (
        <div>
          <h1>Something went wrong.</h1>
          <p>Please try again later or contact support.</p>
        </div>
      );
    }

    return this.props.children; // Render the children if no error
  }
}

export default ErrorBoundary;
